const WEB_FRAME_CONSTANTS = {
  TIMEOUTS: {
    ONE_HUNDRED_MS: 100,
    FIVE_HUNDRED_MS: 500,
    ONE_SECOND: 1000,
    TWO_SECONDS: 2000,
  },
} as const;

export default WEB_FRAME_CONSTANTS;
